<template>
  <v-icon :icon="`$${status}`" />
</template>

<script>
import { get } from 'lodash';
import { mapState } from 'pinia';
import { useContextStore } from '@/stores/context';
import sectionStatuses from '@enums/section-status';

export default {
  props: {
    itemStatus: {
      required: true,
      type: Object,
    },
    subsection: {
      required: true,
      type: String,
    },
  },
  computed: {
    ...mapState(useContextStore, ['getDateFormats']),
    status() {
      return get(this.itemStatus, `${this.subsection}.status`, sectionStatuses.notStarted);
    },
  },
};
</script>
